import { gql, useQuery } from '@apollo/client';

import {
  UsePostHref_Post,
  UsePostHref_PostVariables,
} from './graphql-types/UsePostHref_Post';

const POST = gql`
  query UsePostHref_Post($input: SinglePostInputV2!) {
    postV2(input: $input) {
      result {
        _id
        group {
          _id
        }
      }
    }
  }
`;

export const usePostHref = (id?: string) => {
  const query = useQuery<UsePostHref_Post, UsePostHref_PostVariables>(POST, {
    variables: {
      input: {
        id,
      },
    },
    skip: !id,
  });

  return query.data?.postV2.result
    ? query.data.postV2.result.group
      ? `/community/post/${id}`
      : `/post/${id}`
    : '';
};
